var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactiveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0215 44.2632L40.8175 35.8668M3 47.5C3 37.835 10.835 30 20.5 30M43 40C43 44.1423 39.6423 47.5 35.5 47.5C31.3577 47.5 28 44.1423 28 40C28 35.8577 31.3577 32.5 35.5 32.5C39.6423 32.5 43 35.8577 43 40ZM30.5 12.5C30.5 18.0229 26.0228 22.5 20.5 22.5C14.9771 22.5 10.5 18.0229 10.5 12.5C10.5 6.97715 14.9771 2.5 20.5 2.5C26.0228 2.5 30.5 6.97715 30.5 12.5Z",
    stroke: "#0095FE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactiveUser);
export default __webpack_public_path__ + "static/media/reactiveUser.411275ec9c6e3cdb85edb9ceab61d421.svg";
export { ForwardRef as ReactComponent };